import {asyncSetTimeout} from "../functions/asyncSetTimeout";
import {sceneNamePrefix, scenes, scenesTitles} from './constants'
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 *
 * fetches the scene's script and caches it for future uses
 *
 * @param sceneIndex {number} scene index to be loaded
 * @param isReversed {boolean} (optional) start the scene from the end
 * @returns {Promise<void>}
 */
export async function getCurrentScene(sceneIndex, isReversed = false, isPopState = false) {
  /**
   * @type HTMLVideoElement
   */
  const loaderElementVideo = document.querySelector('.red-boat-loader video');
  document.body.classList.contains('loaded')&&loaderElementVideo&&(loaderElementVideo.currentTime = 0);
  const sceneName = sceneNamePrefix + (sceneIndex + 1)
  if (!scenes[sceneName]) {
    const {default: sceneScript} = await import(`../../blocks/${sceneName}`);
    scenes[sceneName] = sceneScript;
  }
  document.querySelectorAll(`[data-fetch]`).forEach(container => {
    container.innerHTML = ''
    container.classList.remove('active')
  })
  ScrollTrigger.getAll().forEach(s => s.kill());
  // !isPopState && window.history.pushState({sceneIndex}, '', `?scene=${scenesTitles[sceneIndex]}`);

  window.dispatchEvent(new CustomEvent('scene-changed', {detail: sceneIndex}))

  await asyncSetTimeout(500)
  await scenes[sceneName](sceneName, isReversed)
  window.allowGTM && window.dataLayer.push({'event':'load-scene','scene':window.currentScene+1});
  window.dispatchEvent(new Event('scene-map-change'))

}
